import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Measurements from './pages/Measurements';
import Progress from './pages/Progress';
import Admin from './pages/Admin';
import PrivacyPolicy from './pages/PrivacyPolicy';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null, info: null }; }
  componentDidCatch(error, info) { this.setState({ error, info }); }
  render() {
    if (this.state.error) return (
      <div style={{padding:24,fontFamily:'monospace',background:'#0d0b1a',color:'#ff6b9d',minHeight:'100vh',whiteSpace:'pre-wrap'}}>
        <h2>⚠️ {this.state.error?.message || String(this.state.error)}</h2>
        <div style={{fontSize:11,opacity:.6,marginTop:12}}>{this.state.info?.componentStack}</div>
        <button onClick={()=>window.location.reload()} style={{marginTop:16,padding:'8px 20px',background:'#C8005A',color:'#fff',border:'none',borderRadius:8,cursor:'pointer'}}>Reload</button>
      </div>
    );
    return this.props.children;
  }
}

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== 'admin' && user.role !== 'superadmin') return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/privacy"  element={<PrivacyPolicy />} />
        <Route path="/login"    element={<Login />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard"     element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/measurements"  element={<ProtectedRoute><Measurements /></ProtectedRoute>} />
        <Route path="/measurements/new" element={<ProtectedRoute><Measurements /></ProtectedRoute>} />
        <Route path="/progress"      element={<ProtectedRoute><Progress /></ProtectedRoute>} />
        <Route path="/profile"       element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/admin"         element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        <Route path="/admin/client/:clientId" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        <Route path="*"              element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </ErrorBoundary>
  );
}
